
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'StarterMigrateCard',
  props: {
    learnMoreUrl: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: true
    }
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
    }
  }
})
